<header id="top-header-bar" class="hc-header" role="banner">

  <!-- Mobile burger -->
  <button type="button" class="icon-btn mobile-menu-btn" (click)="sidebar.toggleMobile()" aria-label="Menu">
    <i class="fas fa-bars"></i>
  </button>

  <!-- Logo -->
  <div class="logo" (click)="goToDashboard()">
    <img src="assets/logos/logo-sidebar.png" alt="Home Clause" class="logo-img" />
  </div>

  <!-- Contract editor center zone -->
  @if (editorHeader.editorActive()) {
  <div class="header-contract-title">
    @switch (editorHeader.editorType()){
      @case('CONTRACT'){<small>{{ 'navigation.contract' | translate }}</small>}
      @case('TEMPLATE'){<small>{{ 'navigation.template' | translate }}</small>}
    }
    {{ editorHeader.title() }}
  </div>
  }

  <div class="header-spacer"></div>

  <!-- Settings -->
  <button type="button" class="icon-btn" (click)="goToSettings()" [title]="'navigation.settings' | translate">
    <i class="fas fa-cog"></i>
  </button>

  <!-- Notifications -->
  <button type="button" class="icon-btn" [matMenuTriggerFor]="notificationMenu" (click)="loadNotifications()"
          [title]="'notification.popup.title' | translate">
    <i class="far fa-bell"></i>
  </button>

  <mat-menu #notificationMenu="matMenu" class="notification-menu">
    <div class="notification-container">
      <div class="dd-head">
        <strong>{{ 'notification.popup.title' | translate }}</strong>
        <button type="button" class="head-settings" (click)="goToNotificationSettings()" title="Notification Settings">
          <img src="assets/logos/general/notification-icon.svg" alt="Settings">
        </button>
      </div>

      <div class="notification-content">
        @if (recentNotifications.length === 0) {
          <div class="notif-empty">{{ 'notification.popup.empty' | translate }}</div>
        }
        @else {
          @for (notif of recentNotifications; track notif.uuid) {
            <div class="notif-item">
              <a class="notif-body" [href]="notif.link">
                <p>{{ notif.description }}</p>
                <small>
                  @if (notif.dateSinceNumber === '0') {
                    {{ 'notification.popup.time.just-now' | translate }}
                  } @else {
                    {{ 'notification.popup.time.prefix' | translate }}
                    {{ notif.dateSinceNumber }}
                    {{ 'unit.time.' + notif.dateSinceUnit | translate }}
                    {{ 'notification.popup.time.suffix' | translate }}
                  }
                </small>
              </a>

              <button mat-icon-button class="notif-more"
                      [matMenuTriggerFor]="itemMenu"
                      (click)="$event.stopPropagation(); $event.preventDefault()">
                <i class="fas fa-ellipsis-v"></i>
              </button>

              <mat-menu #itemMenu="matMenu">
                <button mat-menu-item (click)="deleteNotification(notif.uuid, $event)">
                  <span class="menu-row">
                    <img src="assets/logos/general/delete-icon.svg" alt="">
                    <span>{{ 'notification.popup.action.delete' | translate }}</span>
                  </span>
                </button>
                <button mat-menu-item (click)="disableNotificationType(notif.type, $event)">
                  <span class="menu-row">
                    <img src="assets/logos/general/blind-icon.svg" alt="">
                    <span>{{ 'notification.popup.action.disable' | translate }}</span>
                  </span>
                </button>
              </mat-menu>
            </div>
          }
        }
      </div>

      <div class="dd-footer" (click)="viewAllNotifications()">
        <i class="fas fa-plus"></i>
        <span>{{ 'notification.popup.more' | translate }}</span>
      </div>
    </div>
  </mat-menu>

  <!-- User chip -->
  <button type="button" class="user-chip" [matMenuTriggerFor]="menuUser">
    <span class="u-info">
      <span class="u-name">{{ userName }}</span><br>
      <span class="u-role">{{ ('user.role.') + userRole | translate }}</span>
    </span>
    <img class="avatar" [src]="profilePic" alt="User Profile">
  </button>

  <mat-menu #menuUser="matMenu" class="userMenu" panelClass="userMenuPanel">
    <button mat-menu-item (click)="goToSettings()">
      <span class="item-text">{{ 'navigation.account-settings' | translate }}</span>
    </button>
    <button mat-menu-item (click)="logout()">
      <span class="item-text">{{ 'navigation.logout' | translate }}</span>
    </button>
  </mat-menu>

  <!-- Governys apps -->
  <button type="button" class="icon-btn" [matMenuTriggerFor]="menu" title="Governys">
    <i class="fas fa-th"></i>
  </button>

  <mat-menu #menu="matMenu" class="custom-menu">
    <div class="apps-grid">
      <button mat-menu-item class="app-tile" (click)="goToScanClause()">
        <figure class="item-img"><img src="assets/logos/header/scan-clause-icon.svg" alt=""></figure>
        <span>Scan Clause</span>
      </button>
      <button mat-menu-item class="app-tile" (click)="goToExigate()">
        <figure class="item-img"><img src="assets/logos/header/exigate-icon.svg" alt=""></figure>
        <span>ExiGate</span>
      </button>
      <button mat-menu-item class="app-tile" (click)="goToDiliplan()">
        <figure class="item-img"><img src="assets/logos/header/diliplan-icon.svg" alt=""></figure>
        <span>DiliPlan</span>
      </button>
      <button mat-menu-item class="app-tile" (click)="goToAudiscope()">
        <figure class="item-img"><img src="assets/logos/header/audiscope-icon.svg" alt=""></figure>
        <span>AudiScope</span>
      </button>
      <button mat-menu-item class="app-tile" (click)="goToBillecho()">
        <figure class="item-img"><img src="assets/logos/header/billecho-icon.svg" alt=""></figure>
        <span>BillEcho</span>
      </button>
      <button mat-menu-item class="app-tile" (click)="goToRiskout()">
        <figure class="item-img"><img src="assets/logos/header/riskout-icon.svg" alt=""></figure>
        <span>RiskOut</span>
      </button>
    </div>
  </mat-menu>

</header>